export const calculateDiscount = (unitPrice: number, totalPrice: number, quantity: number): number | undefined => {
  if (quantity <= 0) {
    return undefined;
  }
  const expectedTotal = unitPrice * quantity;
  const discountAmount = expectedTotal - totalPrice;
  const discount = discountAmount > 0 ? discountAmount / quantity : undefined;

  return discount !== undefined ? Math.round(discount * 100) / 100 : undefined;
};
